
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ibeacon-app-development",
      function () {
        return require("private-next-pages/ibeacon-app-development.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ibeacon-app-development"])
      });
    }
  